import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* employeePlansWatchers() {
  yield all([
    takeEvery(EntryActionTypes.EMPLOYEE_PLANS_IN_CURRENT_BOARD_FETCH, () =>
      services.fetchEmployeePlansInCurrentBoard(),
    ),
    takeEvery(EntryActionTypes.EMPLOYEE_PLAN_IN_CURRENT_BOARD_CREATE, ({ payload: { data } }) =>
      services.createEmployeePlanInCurrentBoard(data),
    ),
    takeEvery(EntryActionTypes.EMPLOYEE_PLAN_UPDATE, ({ payload: { id, data } }) =>
      services.updateEmployeePlan(id, data),
    ),
    takeEvery(EntryActionTypes.EMPLOYEE_PLAN_DELETE, ({ payload: { id } }) =>
      services.deleteEmployeePlan(id),
    ),
  ]);
}

